import { useMemo } from "react";
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import classNames from "classnames";
import styles from "./index.module.scss";

const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
  typographer: true,
  highlight(code, language) {
    const lang = language && hljs.getLanguage(language) ? language : "";

    try {
      const highlighted = lang
        ? hljs.highlight(code, { language: lang, ignoreIllegals: true }).value
        : hljs.highlightAuto(code).value;
      return `<pre class="hljs"><code>${highlighted}</code></pre>`;
    } catch (error) {
      return "";
    }
  },
});

markdown.renderer.rules.link_open = (tokens, index, options, env, self) => {
  const token = tokens[index];
  const href = token.attrGet("href") || "";

  if (/^https?:\/\//i.test(href)) {
    token.attrSet("target", "_blank");
    token.attrSet("rel", "noreferrer");
  }

  return self.renderToken(tokens, index, options);
};

const MarkdownPreview = ({ className, content }) => {
  const html = useMemo(() => markdown.render(content || ""), [content]);

  return (
    <div
      className={classNames(styles.markdownBody, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MarkdownPreview;
